// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Spinner_wrapper__1E77J","spinner":"Spinner_spinner__O9aHx","dotFlashing":"Spinner_dotFlashing__3tg8i"};